import { default as Cookies } from "js-cookie";

const maxAge = 60 * 60 * 24 * 7 * 12 * 1000; // 12 weeks

const getAuthCookieKey = function () {
    const stage = process.env.REACT_APP_STAGE;

    return `Trilo_auth_${stage}`;
};

const getTriloDomain = function () {
    return process.env.REACT_APP_IS_DEV ? "localhost" : "trilo.io";
};

export function getAuthCookieFromRaw(rawCookie: string | undefined) {
    try {
        if (!rawCookie) return {};
        const cookies = parseRawCookies(rawCookie);
        // @ts-ignore
        return cookies[getAuthCookieKey()] || {};
    } catch (e) {
        console.error("getAuthCookieFromRaw failed;", e);
        return {};
    }
}

export function getAuthCookie({
    cookies = Cookies,
}: {
    cookies?: any;
} = {}): {
    identityId?: string;
    refreshToken?: string;
} {
    try {
        const authCookie = cookies.get(getAuthCookieKey());
        console.log("authCookie:", authCookie);
        return JSON.parse(authCookie || "{}");
    } catch (e) {
        console.error("getAuthCookie failed;", e);
        return {};
    }
}

export function setAuthCookies({
    identityId,
    refreshToken,
    cookies = Cookies,
}: {
    identityId?: string;
    refreshToken?: string;
    cookies?: any;
} = {}) {
    try {
        const authCookie: any = {
            identityId,
            refreshToken,
        };
        console.log("[setAuthCookie] authCookie:", authCookie);
        console.log("[setAuthCookie] getAuthCookieKey()", getAuthCookieKey())
        console.log("[setAuthCookie] getTriloDomain()", getTriloDomain())
        const expires = new Date(new Date().getTime() + maxAge);
        cookies.set(getAuthCookieKey(), JSON.stringify(authCookie), {
            expires,
            domain: getTriloDomain(),
            path: "/",
        });
        const result = cookies.get(getAuthCookieKey());
        console.log("[setAuthCookie] result:", result);
    } catch (e) {
        console.error("[setAuthCookie] failed;", e);
    }
}

export function clearAuthCookies({
    cookies = Cookies,
}: {
    cookies?: any;
} = {}) {
    try {
        // using blank set with 0 expire, instead of clear because
        // the clear method requires the exact same expire time to be
        // passed in, and we don't have access to that.
        cookies.set(getAuthCookieKey(), JSON.stringify({}), {
            expires: 0,
            domain: getTriloDomain(),
            path: "/",
        });
    } catch (e) {
        console.error("clearAuthCookie failed;", e);
    }
}

// ----

/**
 * @param cookies - raw cookies directly from the req.header
 *
 * @returns cookies as an object
 */
export function parseRawCookies(cookies: string | string[] | undefined) {
    if (!cookies) return {};
    try {
        return String(cookies)
            .split(";")
            .reduce((res, c) => {
                const [key, val] = c.trim().split("=").map(decodeURIComponent);
                try {
                    return Object.assign(res, { [key]: JSON.parse(val) });
                } catch (e) {
                    return Object.assign(res, { [key]: val });
                }
            }, {});
    } catch (e) {
        return {};
    }
}
